import Axios from 'axios'
import React, { useMemo } from 'react'
import { Switch, Route, BrowserRouter, useParams } from 'react-router-dom'
import FetchboiProvider from './fetchboi/context'
import ErrorBoundary from 'react-error-boundary'
import CongressProvider from './congress/context'
import { apiURL } from './config'
import { hot } from 'react-hot-loader'
import Router from './Router'

function App () {

  return (
    <ErrorBoundary FallbackComponent={Error}>
      <BrowserRouter basename="/landing">
        <Switch>
          <Route path="/:CongressSlug">
            <Content/>
          </Route>
        </Switch>
      </BrowserRouter>
    </ErrorBoundary>
  )
}

function Content () {
  const { CongressSlug } = useParams()

  const axios = useMemo(() => Axios.create({
    baseURL: apiURL,
    params: {
      CongressSlug
    }
  }), [CongressSlug])

  return (
    <FetchboiProvider axios={axios} extract="Data">
      <CongressProvider congressSlug={CongressSlug}>
        <Router/>
      </CongressProvider>
    </FetchboiProvider>
  )
}

export default process.env.NODE_ENV === 'development' ? hot(module)(App) : App

